import { SHORT_SIDO_NAME } from '~constant/common';

function getShortenedAddress(addressCode: string, address: string) {
  if (!address) {
    return '';
  }

  const cityCode = SHORT_SIDO_NAME[addressCode.substring(0, 2)];
  const district = address.split(' ')[1];

  return [cityCode, district].filter((v) => v).join(', ');
}

export default getShortenedAddress;
